import { createFileRoute, redirect } from '@tanstack/react-router'
import { analytics, CobrandedLayout } from 'merchant-components'

// TODO: Delete entire route after XF-528 release
export const Route = createFileRoute('/_merchant/apply')({
  beforeLoad: ({search}) => {
    analytics.track('DeprecatedRoute', { referrer: document.referrer, route: 'apply' });
    throw redirect({ to: '/application', search: search });
  },
  component: CobrandedLayout,
})
